<template>
  <section class="floor-3">
    <div class="content-container">
      <h1 class="title">{{ $t("home.CustomerReviews.h1") }}</h1>
      <p class="sub-title">{{ $t("home.CustomerReviews.pin-yin") }}</p>
      <div class="swiper-container">
        <div class="swiper-wrapper" >
          <div class="swiper-slide" v-for="item in 10" :key="item">
            <div class="text-container">
              <div class="swiper-slide-text-title">
                <strong>{{ $t(`home.CustomerReviews.title-${item < 10 ?  `0${item}` : item}`) }}</strong> · <span>{{ $t(`home.CustomerReviews.subtitle-${item < 10 ?  `0${item}` : item}`) }}</span>
              </div>
              <p>
                {{ $t(`home.CustomerReviews.desc-${item < 10 ?  `0${item}` : item}`) }}
              </p>
            </div>
          </div>
        </div>
        <!-- 如果需要分页器 -->
        <div class="swiper-pagination"></div>
        <!-- 如果需要导航按钮 -->
        <div class="swiper-button-prev"></div>
        <div class="swiper-button-next"></div>
      </div>
    </div>
    <div class="mask"></div>
  </section>
</template>

<script>
import Swiper from "swiper"; // 注意引入的是Swiper
import "swiper/css/swiper.min.css"; // 注意这里的引入

export default {
  data() {
    return {
      swiperInstance: null,
    };
  },
  mounted() {
    let mySwiper = new Swiper(".swiper-container", {
      slidesPerView: 2,
      direction: "horizontal",
      autoplay: {
        // delay: 3000,
        // stopOnLastSlide: false,
        // disableOnInteraction:false,
        pauseOnMouseEnter: true,
      },
      loop: true,

      pagination: {
        el: ".swiper-pagination",
        type: "bullets",
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });

    mySwiper.el.onmouseover = function () {
      mySwiper.autoplay.stop();
    };
    mySwiper.el.onmouseout = function () {
      mySwiper.autoplay.start();
    };
  },
  methods: {},
};
</script>

<style lang="less" scoped>
/* 楼层三：客户评价 */
.floor-3 {
  position: relative;
  height: 757px;
  background: url("../../../assets/images/home/index-bg-03.webp") no-repeat;
  background-size: 100%;

  .mask {
    z-index: 1;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.8);
  }

  .content-container {
    position: absolute;
    z-index: 10;
    width: 100%;
    height: 100%;

    .title {
      margin: 0;
      padding-top: 48px;
      text-align: center;
      color: #ff5d1b;
      font-size: 32px;
    }
    .sub-title {
      margin: 8px 0 100px 0;
      color: #fafafa;
      text-align: center;
      font-size: 13px;
    }

    .swiper-container {
      width: 72%;
      height: 375px;

      .swiper-wrapper {
        .swiper-slide {
          padding: 24px 58px;

          .text-container {
            box-sizing: border-box;
            padding: 24px;
            height: 90%;
            background-color: rgba(255, 255, 255, 0.8);
            border-radius: 12px;
            box-shadow: 0 0 8px rgba(255, 255, 255, 0.8);
            .swiper-slide-text-title {
              padding: 0 0 24px 0;
              text-align: center;
              strong {
                font-size: 24px;
                color: #ff5d1b;
              }
              span {
                font-size: 20px;
              }
            }
          }

          // &:nth-child(2n) {
          //   div{
          //     background-color: pink;
          //   }
          // }
        }
      }
      .swiper-pagination {
        bottom: 0;
      }
    }
  }
}
</style>
